/** sessionStorage flag: Plan-page continuation after /welcome part A. */
export const ONBOARDING_WELCOME_PLAN_TOUR_SESSION_KEY =
  'onboardingWelcomePlanTour';

export const ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS = {
  root: 'onboarding-welcome-plan-tour',
  invite: 'onboarding-welcome-plan-invite',
  contextHint: 'onboarding-welcome-plan-context-hint',
  durationHint: 'onboarding-welcome-plan-duration-hint',
  slot: 'onboarding-welcome-plan-slot',
  duration: 'onboarding-welcome-plan-duration',
  outro: 'onboarding-welcome-plan-outro',
};
